import React from 'react';
import { motion } from 'framer-motion';
import { volumes } from '../data/content';
export function VolumesSection() {
  return <section className="w-full px-5 py-14 sm:py-20" data-id="element-327" data-mp="3utcdx1k8g6px">
      <div className="mx-auto max-w-5xl" data-id="element-328" data-mp="coixn13krvtm">
        <div className="mx-auto max-w-2xl text-center" data-id="element-329" data-mp="cn7soxye8i0x">
          <h2 className="font-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-330" data-mp="7po1kxglkark">
            7 kompletnych tomów
          </h2>
          <p className="mt-3 text-sm text-ink/70 sm:text-base" data-id="element-331" data-mp="3g611kxg88ior">
            Spójna kolejność tematów — od budowy atomu po doświadczenia laboratoryjne.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:gap-6 md:grid-cols-2" data-id="element-332" data-mp="3pvatodb2m1cv">
          {volumes.map((volume, i) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-4 rounded-2xl border border-chem/20 bg-white p-5 shadow-sm shadow-chem/5 sm:gap-6 sm:p-6" data-id="element-333" data-mp="3l42k9h9qqfzp" data-mpi={i}>
              <div className="flex min-w-0 flex-1 flex-col" data-id="element-334" data-mp="2ec8sjahaypnj">
                <span className="font-display text-3xl font-bold leading-none text-chem sm:text-4xl" data-id="element-335" data-mp="2j5tsv96dbvpw">
                  {volume.number}
                </span>
                <h3 className="mt-3 text-base font-bold leading-snug text-ink sm:text-lg" data-id="element-336" data-mp="1qh624y2uoe4y">
                  {volume.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-ink/70" data-id="element-337" data-mp="1vg96egb0agbv">
                  {volume.description}
                </p>
                <div className="mt-auto pt-5" data-id="element-338" data-mp="24gfj3zyvrc9z">
                  <span className="inline-block rounded-full bg-chem/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-chem-deep" data-id="element-339" data-mp="24h71g93gvdib">
                    W cenie pakietu
                  </span>
                </div>
              </div>
              <div className="shrink-0 self-start" data-id="element-340" data-mp="1gqswyvh3tzyx">
                <img src={volume.cover} alt={`Okładka tomu ${volume.number}: ${volume.title}`} loading="lazy" className="block h-[130px] w-[96px] object-contain drop-shadow-[0_10px_18px_rgba(11,29,58,0.18)] sm:h-[190px] sm:w-[140px]" data-id="element-341" data-mp="1gp9gp4vg7ox5" />
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}